import { api } from './client'
import type { OtpRequestResult, PortalMe, PortalSession } from './types'

/**
 * `POST /portal/v1/auth/otp/request|verify`, `GET /auth/me`,
 * `POST /auth/logout` — see types.ts's header comment for why these are
 * hand-typed rather than generated.
 */
export function requestOtp(phone: string): Promise<OtpRequestResult> {
  return api.post<OtpRequestResult>('/auth/otp/request', { phone })
}

export function verifyOtp(phone: string, code: string): Promise<PortalSession> {
  return api.post<PortalSession>('/auth/otp/verify', { phone, code })
}

export function fetchMe(): Promise<PortalMe> {
  return api.get<PortalMe>('/auth/me')
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}
